import { ModalForm } from './ModalForm';
import { Button } from '@/component/Form/Button';
import { Input } from '@/component/Form/Input';
import { Dropdown } from '@/component/Dropdown';
import { useTranslations } from 'next-intl';

export const ModalFormBedrooms = ({
  onCloseModal,
  handleSubmitMobile,
  loading,
  isBedroomInvalid,
  bedroom,
  onBedroomBlur,
  options,
  onSelectBedroom,
  nextButtonText,
  nextButtonIcon,
}) => {
  const t = useTranslations();

  return (
    <ModalForm
      onClose={onCloseModal}
      buttons={
        <>
          <Button theme="text" size="md" onClick={onCloseModal}>
            {'form.home-owner.modal-button-close'}
          </Button>
          <Button
            onClick={handleSubmitMobile}
            icon={nextButtonIcon}
            loading={loading}
            size="md"
          >
            {nextButtonText}
          </Button>
        </>
      }
    >
      <Input
        icon="icon-search"
        label="form.input.bedrooms.label"
        placeholder="form.input.bedrooms.placeholder"
        error={isBedroomInvalid}
        value={bedroom?.label || ''}
        onBlur={onBedroomBlur}
        disabled={loading}
        readOnly
        theme="filled"
        size="lg"
      />
      <div className="relative overflow-x-hidden overflow-y-auto flex flex-1 mb-4 mt-5 min-h-20">
        <Dropdown
          className="absolute top-0 left-0"
          value={bedroom?.value}
          items={options}
          isEmpty={options.length === 0}
          onSelect={onSelectBedroom}
          disabled={loading}
        />
      </div>
    </ModalForm>
  );
};
